<template>
	<div v-if="isShowPage">

		<div class="order-detail">
			
			
			
			
			
			<div class="title">订单状态</div>
			<div class="order-information ">
				<div class="order-information-contentOne">
			
					<div class="contentOne-content">
						<div class="contentOne-content-title">创建时间：</div>
						<div class="contentOne-content-text text-num" style="margin-left: 10px;">
							<div>{{row.order.created_at}}</div>
						</div>
					</div>
			
					<div class="contentOne-content">
						<div class="contentOne-content-title">订单状态：</div>
						<div class="contentOne-content-text text-num" style="color: rgb(255,106,0);margin-left: 10px;">
			
							<!-- 订单状态 (0: 待付款, 1: 已付款, 2: 已完成, 3: 已取消, 4: 已关闭) -->
			
			
							<div v-if="row.order.order_status==0">待付款</div>
							<!-- <div v-else-if="row.order.status ==1&&row.order.express_type==4" >待自提</div>
							<div v-else-if="row.order.status ==1&&row.order.express_type==5">待闪送</div>
							 -->
						
							<div v-else-if="row.order.order_status==1">已付款</div>

							
							<div v-else-if="row.order.order_status==2">已完成</div>
							<div v-else-if="row.order.order_status==3">已取消</div>
							<div v-else-if="row.order.order_status==4">已关闭</div>
			
			
			
						</div>
					</div>
			
			
			
			
			
					<div class="contentOne-content">
						<div class="contentOne-content-title">发票状态：</div>
						<div class="contentOne-content-text text-num" style="color: rgb(255,106,0);margin-left: 10px;">
			
							<!-- 发票状态 (0: 无需发票, 1: 申请发票, 2: 已开票)-->
							<div v-if="row.order.invoice_status==0">无需发票</div>
							<div v-else-if="row.order.invoice_status==1">申请发票</div>
							<div v-else-if="row.order.invoice_status==2">已开票</div>
			
						</div>
					</div>
			
					<!-- 发票信息start-->
					<div v-if="(row.order.invoice_status==1||row.order.invoice_status==2)&&row.order.invoice">
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="flex-shrink: 0;">发票类型：</div>
							<!-- 1: 个人, 2: 公司 -->
							<div v-if="row.order.invoice.htype==1" class="contentOne-content-text text-num">个人</div>
							<div v-if="row.order.invoice.htype==2" class="contentOne-content-text text-num">公司</div>
						</div>
			
			
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="flex-shrink: 0;">抬头名称：</div>
							<div class="contentOne-content-text text-num">{{row.order.invoice.hname}}</div>
						</div>
			
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="flex-shrink: 0;">税号：</div>
							<div class="contentOne-content-text text-num">{{row.order.invoice.taxfile}}</div>
						</div>
			
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="flex-shrink: 0;">邮箱地址：</div>
							<div class="contentOne-content-text text-num">{{row.order.invoice.email}}</div>
						</div>
			
					</div>
					<!-- 发票信息end -->
			
				</div>
			</div>
			
			
			


			<div class="title" style="margin-top: 30px;">用户信息</div>
			<div class="order-information " >
				<div class="order-information-contentOne">
					<!-- 用户start -->
					<div class="contentOne-content">
						<div class="contentOne-content-title">用户头像：</div>
						<img :src="row.order.user.avatar" style="margin-top: -10px; width: 50px;height: 50px;border-radius: 50%;cursor: pointer;margin-right: 10px;" @click="handlePreView(row.order.user.avatar)" />

					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title">用户昵称：</div>
						<div class="contentOne-content-text text-num">{{row.order.user.nickname}}</div>

					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 1em;">手机号：</div>
						<div class="contentOne-content-text text-num">{{row.order.user?row.order.user.mobile:''}}</div>

					</div>


					<div class="contentOne-content">
						<!-- 角色 (0: 大众, 1: 会员, 2: 城代) -->
						<div class="contentOne-content-title" style="margin-left: 2em;">角色：</div>
						<div v-if="row.order.role==0" class="contentOne-content-text text-num">大众</div>
						<div v-if="row.order.role==1" class="contentOne-content-text text-num">会员</div>
						<div v-if="row.order.role==2" class="contentOne-content-text text-num">城代</div>
						<div v-if="row.order.role==3" class="contentOne-content-text text-num">供货</div>
					</div>
					
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 0em;">etm姓名：</div>
						<div class="contentOne-content-text text-num">{{row.order.user?row.order.user.etm_name:''}}</div>
					
					</div>
					
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 0em;">etm昵称：</div>
						<div class="contentOne-content-text text-num">{{row.order.user?row.order.user.etm_nickname:''}}</div>
					
					</div>
					
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 2em;">生日：</div>
						<div class="contentOne-content-text text-num">{{row.order.user?row.order.user.birthday:''}}</div>
					
					</div>

					<!-- <div class="contentOne-content">
						
						<div class="contentOne-content-title">用户性别：</div>
						<div v-if="row.order.user.sex==0" class="contentOne-content-text text-num">未知</div>
						<div v-if="row.order.user.sex==1" class="contentOne-content-text text-num">男</div>
						<div v-if="row.order.user.sex==2" class="contentOne-content-text text-num">女</div>
					</div> -->

					<div class="contentOne-content">
						<div class="contentOne-content-title">收货人名：</div>
						<div class="contentOne-content-text text-num">{{row.order.address?row.order.address.name:''}}</div>

					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title">收货电话：</div>
						<div class="contentOne-content-text text-num">{{row.order.address?row.order.address.mobile:''}}</div>

					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="flex-shrink: 0;">收货地址：</div>
						<div class="contentOne-content-text text-num">{{row.order.address?row.order.address.address:''}}</div>

					</div>

					<!-- 用户end -->

				</div>


				<div class="order-information-contentOne">

					<!-- 门店start -->
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 2em;">门店图片：</div>
						<img v-if="row.order.store" :src="row.order.store?row.order.store.image:''" style="margin-top: -10px; width: 50px;height: 50px;border-radius: 50%;cursor: pointer;margin-right: 10px;" @click="handlePreView(row.order.store.image)" />

					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 2em;">门店名称：</div>
						<div class="contentOne-content-text text-num">{{row.order.store?row.order.store.name:'无'}}</div>

					</div>

					<div class="contentOne-content">

						<!-- 补款状态 (0: 未补款, 1: 已补款, 3: 无需操作)-->
						<div class="contentOne-content-title">门店补款状态：</div>
						<div v-if="row.order.repayment_status==0" class="contentOne-content-text text-num">未补款</div>
						<div v-if="row.order.repayment_status==1" class="contentOne-content-text text-num">已补款</div>
						<div v-if="row.order.repayment_status==2" class="contentOne-content-text text-num">已退回</div>
						
						<div v-if="row.order.repayment_status==3" class="contentOne-content-text text-num">无需操作</div>
						<div v-if="row.order.repayment_status==4" class="contentOne-content-text text-num">已确认</div>
					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title">门店补款金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.repayment_price}}</div>
					</div>

					<div class="contentOne-content">
						<!-- 返现状态 (0: 未发放, 1: 已发放, 3: 无需操作) -->
						<div class="contentOne-content-title">门店返现状态：</div>
						<div v-if="row.order.bounty_status==0" class="contentOne-content-text text-num">未发放</div>
						<div v-if="row.order.bounty_status==1" class="contentOne-content-text text-num">已发放</div>
						<div v-if="row.order.bounty_status==3" class="contentOne-content-text text-num">无需操作</div>
					</div>
					<div class="contentOne-content">
						<div class="contentOne-content-title">门店返现金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.bounty_price}}</div>
					</div>





					<!-- 门店end -->

				</div>




			</div>






		</div>


		<div class="order-detail">
			<div class="title">订单详情</div>
			<div class="order-information ">
				<div class="order-information-contentOne">
					<div class="contentOne-content">
						<div class="contentOne-content-title" style="margin-left: 3em;">id：</div>
						<div class="contentOne-content-text text-num">{{row.order.id}}</div>
					</div>


					<div class="contentOne-content">
						<div class="contentOne-content-title">订单编号：</div>
						<div class="contentOne-content-text text-num">{{row.order.order_code}}</div>
					</div>


					<div class="contentOne-content">
						<div class="contentOne-content-title">订单金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.order_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">积分金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.credit_price}}</div>
					</div>
					
					<div class="contentOne-content">
						<div class="contentOne-content-title">商品金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.goods_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">供货金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.supply_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">优惠金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.discount_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">付款金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.payment_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">退款金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.refund_price}}</div>
					</div>



					<div class="contentOne-content">
						<div class="contentOne-content-title">课时合同：</div>
						<div class="contentOne-content-text text-num">{{row.order.course_code}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">课时单价：</div>
						<div class="contentOne-content-text text-num">{{row.order.course_unit_price}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">课时数量：</div>
						<div class="contentOne-content-text text-num">{{row.order.course_count}}</div>
					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">课时金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.course_price}}</div>
					</div>

					<div class="contentOne-content">
						<!-- 课时状态 (0: 未扣除, 1: 已扣除, 3: 无需操作) -->

						<div class="contentOne-content-title">课时状态：</div>
						<div v-if="row.order.course_status==0" class="contentOne-content-text text-num">未扣除</div>
						<div v-if="row.order.course_status==1" class="contentOne-content-text text-num">已扣除</div>

						<div v-if="row.order.course_status==3" class="contentOne-content-text text-num">无需操作</div>
					</div>

					<div class="contentOne-content">
						<!-- (0: 普通商品, 1: 卡券商品) -->

						<div class="contentOne-content-title">商品类型：</div>
						<div v-if="row.order.activity_type==0" class="contentOne-content-text text-num">普通商品</div>
						<div v-if="row.order.activity_type==1" class="contentOne-content-text text-num">卡券商品</div>
						<div v-if="row.order.activity_type==3" class="contentOne-content-text text-num">课时商品</div>
						<div v-if="row.order.activity_type==4" class="contentOne-content-text text-num">课时活动</div>
						<div v-if="row.order.activity_type==5" class="contentOne-content-text text-num">体验课程</div>
					</div>

					<div v-if="row.order.activity_type==1" class="contentOne-content">

						<div class="contentOne-content-title">预约时间：</div>
						<div class="contentOne-content-text text-num">{{row.order.create_date}}</div>

					</div>


					<div class="contentOne-content">
						<div class="contentOne-content-title">奖励积分：</div>
						<div class="contentOne-content-text text-num">{{row.order.bounty_credit}}</div>
					</div>

					<div class="contentOne-content">
						<!-- 奖励积分状态 (0: 未发放, 1: 已发放, 3: 无需操作) -->

						<div class="contentOne-content-title" style="margin-left: -2em;">奖励积分状态：</div>
						<div v-if="row.order.credit_status==0" class="contentOne-content-text text-num">未发放</div>
						<div v-if="row.order.credit_status==1" class="contentOne-content-text text-num">已发放</div>

						<div v-if="row.order.credit_status==3" class="contentOne-content-text text-num">无需操作</div>
					</div>







				</div>

				<!-- 发货的物流信息start v-if="row.order.express_name" -->
				<div class="order-information-contentOne">


					<!-- 快递类型 (1: 在线支付, 2: 到付, 3: 包邮, 4: 自提, 5: 闪送, 6: 邮寄) -->
					<div class="contentOne-content">
						<div class="contentOne-content-title">快递类型：</div>
						<div v-if="row.order.express_type==1" class="contentOne-content-text text-num">在线支付</div>
						<div v-if="row.order.express_type==2" class="contentOne-content-text text-num">到付</div>
						<div v-if="row.order.express_type==3" class="contentOne-content-text text-num">包邮</div>
						
						<div v-if="row.order.express_type==4&&row.order.activity_type==4" class="contentOne-content-text text-num">核销</div>
						<div v-if="row.order.express_type==4&&row.order.activity_type==5" class="contentOne-content-text text-num">核销</div>
						<div v-else-if="row.order.express_type==4" class="contentOne-content-text text-num">自提</div>
						
						
						<div v-if="row.order.express_type==5" class="contentOne-content-text text-num">闪送</div>
						<div v-if="row.order.express_type==6" class="contentOne-content-text text-num">邮寄</div>

					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">运费金额：</div>
						<div class="contentOne-content-text text-num">{{row.order.express_price}}</div>

					</div>

<!-- 
					<div class="contentOne-content">
						<div class="contentOne-content-title">快递名称：</div>
						<div class="contentOne-content-text text-num">{{row.order.express_name}}</div>

					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">快递编码：</div>
						<div class="contentOne-content-text text-num">{{row.order.express_num}}</div>

					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">快递单号：</div>
						<div class="contentOne-content-text text-num">{{row.order.express_code}}</div>

					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">发货时间：</div>
						<div class="contentOne-content-text text-num">{{row.order.express_time}}</div>

					</div> -->
					<div v-if="row.order.complete_time!=0" class="contentOne-content">
						<div class="contentOne-content-title">完成时间：</div>
						<div class="contentOne-content-text text-num">{{row.order.complete_time | dateNumToString}}</div>

					</div>

					<div class="contentOne-content">
						<div class="contentOne-content-title">订单备注：</div>
						<div class="contentOne-content-text text-num">{{row.order.remark}}</div>

					</div>
					
					<div v-if="row.order.activity_type==5" class="contentOne-content">
						<div class="contentOne-content-title">宝宝昵称：</div>
						<div class="contentOne-content-text text-num">{{row.order.baby_name?row.order.baby_name:''}}</div>
					
					</div>
					
					<teleport v-if="row.order.share_user">
						
						<div class="contentOne-content" style="margin-top:25px">
							<div class="contentOne-content-title" style="margin-left: -2em;">分享用户头像：</div>
							<img :src="row.order.share_user.avatar" style="margin-top: -10px; width: 50px;height: 50px;border-radius: 50%;cursor: pointer;margin-right: 10px;" @click="handlePreView(row.order.share_user.avatar)" />
						
						</div>
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="margin-left: -2em;">分享用户昵称：</div>
							<div class="contentOne-content-text text-num">{{row.order.share_user.nickname}}</div>
						
						</div>
						<div class="contentOne-content">
							<div class="contentOne-content-title" style="margin-left: -3em;">分享用户手机号：</div>
							<div class="contentOne-content-text text-num">{{row.order.share_user.mobile}}</div>
						
						</div>
						
						
					</teleport>
					



				</div>

				<!-- 发货的物流信息end -->


			</div>

		</div>


		<div class="shop-information">
			<div class="title" style="margin-bottom:0;">商品信息</div>

			<el-table :data="row.order.goods">
				<el-table-column style="width: 100%;">
					<template slot-scope="itemObj">
						<div>


							<div class="titleFont" style="flex-wrap: wrap;display: flex;align-items: center;  font-size: 10px;color: rgb(136, 136, 136);text-align: left;padding-left: 20px;padding-right: 20px;background-color: #f8f8f8;padding-top: 5px;padding-bottom: 5px;border-radius: 20px;">

								<!-- 状态 (0: 待付款, 1: 待发货, 2: 待收货, 3: 已完成, 4: 已取消, 5: 申请退款, 6: 退货中, 7: 退货完成) -->
								<span v-if="itemObj.row.status==0" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待付款</span>
								
								<span v-else-if="itemObj.row.status==1&&row.order.express_type==4&&(row.order.activity_type==1||row.order.activity_type==0||row.order.activity_type==3)" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待自提</span>
								<span v-else-if="itemObj.row.status==1&&row.order.express_type==4&&row.order.activity_type==4" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待核销</span>
								<span v-else-if="itemObj.row.status==1&&row.order.express_type==4&&row.order.activity_type==5" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待体验</span>
								<span v-else-if="itemObj.row.status==1&&row.order.express_type==5" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待闪送</span>
								
								
								<span v-else-if="itemObj.row.status==1" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待发货</span>
								<span v-else-if="itemObj.row.status==2" style="color:rgb(45, 140, 240);font-weight:bold;">状态: 待收货</span>
								<span v-else-if="itemObj.row.status==3" style="color:limegreen;font-weight:bold;">状态: 已完成</span>
								<span v-else-if="itemObj.row.status==4" style="color:limegreen;font-weight:bold;">状态: 已取消</span>
								<span v-else-if="itemObj.row.status==5" style="color:red;font-weight:bold;">状态: 申请退款</span>
								<span v-else-if="itemObj.row.status==6" style="color:red;font-weight:bold;">状态: 退货中</span>
								<span v-else-if="itemObj.row.status==7" style="color:limegreen;font-weight:bold;">状态: 退货完成</span>


								<span style="margin-left: 20px;">发货快递名称:</span><span style="margin-left: 6px;">{{itemObj.row.express_name?itemObj.row.express_name:'无'}}</span>
								<span style="margin-left: 20px;">发货快递单号:</span><span style="margin-left: 6px;">{{itemObj.row.express_num?itemObj.row.express_num:'无'}}</span>
								
								<template v-if="itemObj.row.express_time">
									<span style="margin-left: 20px;">发货时间:</span>
									<span v-if="itemObj.row.express_time" style="margin-left: 6px;">{{ itemObj.row.express_time | dateNumToString }}</span>
									<span v-else style="margin-left: 6px;">无</span>
								</template>
								
								<template v-if="itemObj.row.receive_time">
									<span style="margin-left: 20px;">收货时间:</span>
									<span v-if="itemObj.row.receive_time" style="margin-left: 6px;">{{itemObj.row.receive_time  | dateNumToString}}</span>
									<span v-else style="margin-left: 6px;">无</span>
								</template>
								
								
								<template v-if="itemObj.row.refund">
									<span style="margin-left: 20px;">退货快递名称：</span>
									<el-tooltip :content="itemObj.row.refund.express_name+''"><span style="margin-left: 6px;display: inline-block;max-width:100px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"> {{itemObj.row.refund.express_name}} </span></el-tooltip>
									
									<span style="margin-left: 20px;">退货快递单号：</span>
									<el-tooltip :content="itemObj.row.refund.express_num+''"><span style="margin-left: 6px;display: inline-block;max-width:100px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"> {{itemObj.row.refund.express_num}} </span></el-tooltip>
													
									<!-- <span style="margin-left: 20px;">退货时间：</span>
									<el-tooltip :content="itemObj.row.refund.express_num+''"><span style="margin-left: 6px;display: inline-block;max-width:100px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"> {{itemObj.row.refund.express_num}} </span></el-tooltip>
												 -->				
								
								</template>							
								
								<template v-if="itemObj.row.refund_content">

									<span style="margin-left: 20px;">退款原因:</span>
									<el-tooltip :content="itemObj.row.refund_content+''"><span style="margin-left: 6px;display: inline-block;max-width:100px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"> {{itemObj.row.refund_content?itemObj.row.refund_content:'无'}} </span></el-tooltip>

								</template>
								
								
								
								
								
								
							</div>

							<div class="tableTem" style="display: flex;align-items: center;margin-left: 20px;margin-bottom: 10px;">
								<div class="avatar" style="padding-top: 15px;">

									<!-- 商品start -->
									<div style="width: 260px;padding-right: 10px;max-height: 180px;overflow-y: auto;">
										<!-- .slice(0,2) -->
										<div style="margin: 0px 3px;margin-top: 10px;  display: flex;justify-content: space-between;">
											<div style="color: rgb(136, 136, 136);">
												<div style="display: flex;">
													<img :src="itemObj.row.image" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;cursor: pointer;" @click="handlePreView(itemObj.row.image)" />
													<div style="text-align: left;">
														<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
															<el-tooltip :content="itemObj.row.name" placement="right">
																<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">{{itemObj.row.name}}</div>

															</el-tooltip>
														</div>


														<div v-if="itemObj.row.specs_value_str" style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
															<el-tooltip :content="itemObj.row.specs_value_str" placement="right">
																<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">规格: {{itemObj.row.specs_value_str}}</div>

															</el-tooltip>
														</div>
														<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
															<el-tooltip :content="itemObj.row.count+''" placement="right">
																<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">数量: {{itemObj.row.count}}</div>

															</el-tooltip>
														</div>




													</div>
												</div>

											</div>


										</div>


									</div>
									<!-- 商品end -->


								</div>

								<ul>

									<li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="itemObj.row.id+''" placement="right">
												<div class="dian">{{itemObj.row.id}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">id</div>
									</li>

									<li style="border-left: none;">
										<div class="content">

											<div v-if="itemObj.row.store_id==0" class="dian">总部商品</div>
											<div v-else class="dian">门店商品</div>

										</div>
										<div class="titleFont">商品类别</div>
									</li>

									<li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="itemObj.row.express_desc+''" placement="right">
												<div class="dian">{{itemObj.row.express_desc}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">发货描述</div>
									</li>
                  <li style="border-left: none;">
                    <div class="content">
                      <el-tooltip :content="itemObj.row.is_postage+''" placement="right">
                        <div class="dian">{{itemObj.row.is_postage==0?'不包邮':'包邮'}}</div>
                      </el-tooltip>
                    </div>
                    <div class="titleFont">是否包邮</div>
                  </li>
									<li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="itemObj.row.credit_price+''" placement="right">
												<div class="dian">{{itemObj.row.credit_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">积分总价</div>
									</li>
									<li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="itemObj.row.goods_price+''" placement="right">
												<div class="dian">{{itemObj.row.goods_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">商品总价</div>
									</li>
									<li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="itemObj.row.supply_price+''" placement="right">
												<div class="dian">{{itemObj.row.supply_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">供货总价</div>
									</li>
									<li style="border-left: none;">
										<div class="content">

											<div class="dian">{{itemObj.row.is_course==1?'是':'否'}}</div>

										</div>
										<div class="titleFont">课时抵扣</div>
									</li>
									<li style="border-left: none;">
										<div class="content">

											<div class="dian">{{itemObj.row.is_coupon==1?'是':'否'}}</div>

										</div>
										<div class="titleFont">优惠券抵扣</div>
									</li>




								</ul>



								<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
									<!-- <el-dropdown trigger="hover" style="width: 80px;">
										<el-button size="mini" round type="primary">
											操作<i class="el-icon-arrow-down el-icon--right"></i>
										</el-button>
										<el-dropdown-menu slot="dropdown">
											<div class="dis" style="flex-direction: column;">

												<el-dropdown-item>
													<el-button type="warning" size="mini" round>已开发票
													</el-button>
												</el-dropdown-item>
											</div>


										</el-dropdown-menu>
									</el-dropdown> -->
									
									<el-button v-if="itemObj.row.express_num" type="success" size="mini" round @click="showWuLiu(itemObj.row)">查看物流
									</el-button>
								
								</div>
							</div>
						</div>

					</template>
				</el-table-column>
			</el-table>

		</div>




		<el-dialog :close-on-click-modal="false" title="预览" :modal="false" width="400px" :visible.sync="preShow">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
		
		
		
		<!-- 物流信息弹窗start -->
		<el-dialog :modal="false" :close-on-click-modal="false" center :visible.sync="isShowWuLiu" title="物流信息" width="700px">
		
			<div>
		
				<!-- 物流信息start -->
				<div style="padding: 20px;border-top: 1rpx solid #fff;padding-top: 0;">
		
					<div class="dis" style="font-weight: bold; font-size: 14px;padding: 10px 0;color: #393939;padding-bottom: 20px;">
						<div class="dis">
							<div>{{currentWuLiu.express_name}}</div>
							<div style="margin-left: 10px;">{{currentWuLiu.express_num}}</div>
		
						</div>
		
					</div>
		
					<!-- 物流时间轴 -->
					<div>
		
						<template v-if="currentWuLiu.detail&&currentWuLiu.detail.length>0">
							<div v-for="(item,index) in currentWuLiu.detail" :key="index">
		
								<div style="position: relative;display: flex;align-items: center;color:#9A9A9A;padding-left: 10px;">
		
									<div :style="{'background-color': index==0?'red':'#9A9A9A'}" style="width: 10px;height: 10px;border-radius: 50%;position: absolute;top:50%;left:5px;transform: translateY(-50%);"></div>
		
									<div style="padding:15px;padding-left: 20px; border-left: 1px solid rgba(207, 207, 207, 0.3);padding-right: 10px;">
										<div style="margin-bottom: 10px;">{{item.time}}</div>
										{{item.context}}
									</div>
		
								</div>
		
							</div>
						</template>
						<div v-else style="text-align: center;margin: 50px 0;color: #9A9A9A;">暂无物流信息~</div>
		
					</div>
				</div>
		
			</div>
			<!-- 物流信息end -->
		</el-dialog>
		<!--物流信息弹出end -->


	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	export default {
		name: '',
		components: {},
		data() {
			return {
				
				currentWuLiu: '', //当前显示的物流数据
				isShowWuLiu: false, //是否显示物流信息
				
				row: {}, //当前显示的订单详情对象
				preImgUrl: '',
				preShow: false,
				loading: false,
				isShowPage: false
			}
		},

		filters: {
			dateNumToString(num) {
				
				
				let d = new Date(num*1000);
				
				var _y = d.getFullYear();
				var _m = d.getMonth() < 10 ? "0" + d.getMonth() : d.getMonth();
				var _d = d.getDate() < 10 ? "0" + d.getDate() : d.getDate(); 
				var _w = d.getDay();
				var _h = d.getHours() < 10 ? "0" + d.getHours() : d.getHours(); 
				var _mm = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
				var _s =  d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
				//字符串的拼接
				var str = _y + "-" + (parseInt(_m) + 1) + "-" + _d + " " + _h + ":" + _mm;
				return str;

			}




		},


		mounted() {

		},
		methods: {
			

			async initData(row) {
				this.loading = true;
				//获取订单详情
				let res = await ajax('/order/detail', 'GET', {
					order_id: row.id
				});
				const data = res.data.data;
				this.row = data;
				this.loading = false;
				this.isShowPage = true;

			},
			handlePreView(url) {
				this.preImgUrl = url
				this.preShow = true
			},
			
	
			//显示物流信息
			async showWuLiu(row) {
				console.log('row',row);
				this.loading = true;
				let res = await ajax('/order/express', 'GET', {
					
					name:row.express_name,
					code:row.express_code,
					num:row.express_num
				});
				const express = res.data.data.express;
				this.loading = false;
			
			
				//没有物流
				if (!express) {
					this.$message.error('暂无物流信息')
					return;
				}
			
			
				this.currentWuLiu = express; //当前显示的物流数据
				this.isShowWuLiu = true; //是否显示物流信息
				console.log('this.isShowWuLiu', this.isShowWuLiu)
			
			},
			
		}
	}
</script>

<style scoped lang="scss">
	.title {
		color: #333333;
		margin-bottom: 24px;
		width: 100%;
		height: 16px;
		line-height: 16px;
		padding-left: 10px;
		border-left: 3px solid rgb(254, 106, 0);
		box-sizing: border-box;
		font-size: 15px;
		font-weight: bold;
	}

	.order-detail {
		padding: 15px;
		box-sizing: border-box;
		background: white;
	}

	.order-information>div:nth-child(1) {
		border-left: none;
	}

	.order-information-contentOne {
		width: 50%;
		height: 100%;
		padding: 0 48px;
		box-sizing: border-box;
	}

	.order-information {

		width: 100%;
		min-height: 40px;
		display: flex;
	}

	.contentOne-content {
		display: flex;
		font-size: 14px;
		color: rgb(164, 164, 164);
		margin-bottom: 14px;
	}

	.shop-information {
		width: 100%;
		background: white;
		padding: 15px;
		box-sizing: border-box;
		margin-top: 15px;
	}

	.shop-information-table {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.shop-information-table>table {
		width: 100%;
		border: 1px solid rgb(238, 238, 238);
		border-bottom: none;
	}

	.table-trThree {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-top: 1px solid rgb(238, 238, 238);
		max-width: 100%;
		min-height: 40px;
		padding: 16px 28px;
		box-sizing: border-box;
		border: 1px solid rgb(238, 238, 238);
	}

	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}


	.table-settlement {
		margin: 10px 0 20px;
		color: #333333;
		text-align: right;
	}

	.table-trOne {
		height: 48px;
		background: rgb(245, 245, 245);
	}

	.th {
		text-align: center;
		/* padding-left: 28px; */
		box-sizing: border-box;
		font-weight: 500;
		color: #333333;
		border-right: 1px solid rgb(238, 238, 238);
	}

	.tbody {
		display: table-row-group;
		vertical-align: middle;
		border-color: inherit;
	}

	.table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	.table-trTow {
		width: 100%;
		height: 60px;
		border-top: 1px solid rgb(238, 238, 238);
	}

	.table-trTow>.td {
		text-align: center;
		/* padding-left: 28px; */
		box-sizing: border-box;
		font-weight: 500;
		color: #333333;
		border-right: 1px solid rgb(238, 238, 238);
	}

	.table-trThree>div {
		font-weight: 500;
		color: #333333;
	}

	.table-trThree>div>p:nth-child(1) {
		margin-bottom: 8px;
	}

	.table-trThree>div>p {
		color: rgb(164, 164, 164);
	}

	.table-trThree>div>p {
		display: flex;
		align-items: center;
	}

	.table-trThree>div>p>span {
		color: #333333;
	}

	.table-settlement>span:nth-child(2) {
		color: rgb(255, 106, 0);
		font-size: 15px;
	}

	.contentOne-content-title {
		flex-shrink: 0;
	}

	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: end;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	>>>.el-table tbody tr:hover>td {
		background-color: transparent !important;
	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;

		font-weight: 600;
	}



	.tableTem .avatar img {
		border-radius: 50%;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {
		/* height: 120px; */

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}
</style>
